import { Box, TextField, InputAdornment, IconButton, Chip } from '@mui/material';
import { Search, Close, Article } from '@mui/icons-material';

export default function DetailSearch({ value, onChange, onClear, episodeTitle }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: { xs: 'stretch', sm: 'flex-end' },
        width: '100%',
        minWidth: 0
      }}
    >
      {/* Scope Indicator */}
      {episodeTitle && (
        <Chip
          icon={<Article fontSize="small" />}
          label={`Searching in: ${episodeTitle}`}
          title={`Searching in: ${episodeTitle}`}
          size="small"
          variant="outlined"
          sx={{
            alignSelf: { xs: 'stretch', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            maxWidth: '100%',
            minHeight: { xs: 36, sm: 32 },
            borderColor: 'primary.main',
            color: 'primary.main',
            fontWeight: 500,
            fontSize: { xs: '0.8rem', sm: '0.75rem' },
            '& .MuiChip-label': {
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }}
        />
      )}

      {/* Search Input */}
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search transcript..."
        size="small"
        sx={{
          width: '100%',
          maxWidth: { sm: 300 },
          minWidth: 0,
          '& .MuiOutlinedInput-root': {
            bgcolor: 'background.paper'
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" color="primary" />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onClear} aria-label="Clear transcript search">
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }}
        inputProps={{ 'aria-label': 'Search this transcript', type: 'search' }}
      />
    </Box>
  );
}
